export default class OrganizationsService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/organizations/';

  constructor(private $http) {
    'ngInject';
  }

  setGroupNotification(
    organizationId: number,
    notificationName: string,
    isSubscribed: boolean
  ): ng.IPromise<any> {
    return this.$http.put(
      `${this.baseUrl}${organizationId}/notificationsubscriptions/${notificationName}`,
      {
        subscribed: isSubscribed,
        scope: 'GROUP_MEMBER'
      }
    );
  }

  addUsers(orgId: number, users: any) {
    return this.$http.post(`${this.baseUrl}${orgId}/users`, {
      users
    });
  }

  getOrganization(orgId: number): ng.IPromise<any> {
    return this.$http.get(`${this.baseUrl}${orgId}`);
  }

  getCpaStatistics(orgId: number) {
    return this.$http.get(`${this.baseUrl}${orgId}/cpas/statistics`);
  }

  getDocuments(orgId: number) {
    return this.$http.get(`${this.baseUrl}${orgId}/documents`);
  }

  getContracts(orgId: number, cache: boolean = true) {
    return this.$http.get(`${this.baseUrl}${orgId}/contracts`, { cache });
  }
}
